import { useAtomValue } from "jotai";
import { Center } from "@react-three/drei";
import layout from "../../dictionaries/layout.js";
import { deviceAtom } from "../../GlobalState.jsx";
import AudioButton from "../../soundPlayers/AudioButton.jsx";
import LanguageButton from "./LanguageButton.jsx";

export default function AudioButtonSection({ position }) {
  const device = useAtomValue(deviceAtom)
  return <Center position={position}>
    <AudioButton 
    position={layout[device].lobby.lobbySettingsSection.audioButton.position} 
    scale={layout[device].lobby.lobbySettingsSection.audioButton.scale}
    rotation={layout[device].lobby.lobbySettingsSection.audioButton.rotation}
    />
    <LanguageButton 
    position={layout[device].lobby.lobbySettingsSection.languageButton.position} 
    scale={layout[device].lobby.lobbySettingsSection.languageButton.scale}
    rotation={layout[device].lobby.lobbySettingsSection.languageButton.rotation}
    />
  </Center>
}
